// extracted by mini-css-extract-plugin
export default {"pageHeader":"Achievements_pageHeader__fpDKK"};